var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRngParticipantRound = function SvgRngParticipantRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "inherit",
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 8h6c0 1.09-1.309 2-3.054 2C14.31 10 13 9.09 13 8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 13.208c0 .197 0 .295-.104.393l-3.446 3.734c0 .098-.209.197-.313.197-.209 0-.313 0-.418-.099l-1.984-1.572v8.648c0 .196-.104.294-.209.393 0 0-.208.098-.313.098H9.788c-.21 0-.314 0-.418-.098-.105-.099-.105-.295-.105-.393v-8.55l-1.984 1.573c-.104.196-.313.196-.417.196-.105 0-.209-.196-.313-.295L3.105 13.7C3 13.601 3 13.405 3 13.306c0-.196.105-.294.21-.393l5.324-4.029A3.881 3.881 0 0 1 11.04 8h1.045c0 1.769 1.775 3.145 3.968 3.145 2.088 0 3.863-1.376 3.863-3.145h1.044c.94 0 1.775.295 2.506.884l5.325 4.03c.105.098.21.196.21.294Z",
    fill: "currentColor"
  })));
};
export { SvgRngParticipantRound as ReactComponent };